var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasChart)?_c('div',[_c('div',{staticClass:"tw-flex tw-mb-4 tw-items-center tw-justify-center tw-text-xs tw-text-gray-400"},[_c('div',{staticClass:"tw-mt-4 tw-px-4"},[_c('span',{staticClass:"tw-inline-block tw-h-2 tw-w-2 tw-rounded-full tw-bg-indigo-500 tw-mr-2"}),_vm._v(" "+_vm._s(_vm.$t("meetings.analytics.insights.chart.labelIndividual"))+" ")]),_c('div',{staticClass:"tw-mt-4 tw-px-6"},[_c('span',{staticClass:"tw-inline-block tw-h-2 tw-w-2 tw-rounded-full tw-bg-indigo-200 tw-mr-2"}),_vm._v(" "+_vm._s(_vm.$t("meetings.analytics.insights.chart.labelTeam"))+" ")])]),(_vm.highestTimelineDate && _vm.lowestTimelineDate)?_c('l-chart',{attrs:{"options":_vm.chartOptions,"colors":['primary', 'primaryLow'],"data":{
            labels: [],
            datasets: [
                {
                    data: _vm.fillTimeSeriesData(
                        _vm.timelines.timelineIndividual,
                        _vm.$moment,
                        365,
                        _vm.highestTimelineDate,
                        _vm.lowestTimelineDate
                    ),
                    maxBarThickness: 12,
                },
                {
                    data: _vm.fillTimeSeriesData(
                        _vm.timelines.timelineTeam,
                        _vm.$moment,
                        365,
                        _vm.highestTimelineDate,
                        _vm.lowestTimelineDate
                    ),
                    maxBarThickness: 12,
                } ],
        },"type":"bar","height":("" + _vm.height)}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }